module.exports = __webpack_public_path__ + "static/media/Cheese-removebg-preview.c76a2b39.png";